import React from 'react';
import PropTypes from 'prop-types';
import {
  IconAndroidColor,
  IconChromeColor,
  IconEdgeColor,
  IconFirefoxColor,
  IconGoogleColor,
  IconIexploreColor,
  IconIosColor,
  IconLinuxColor,
  IconMacosColor,
  IconOperaColor,
  IconSafariColor,
  IconWindowsColor,
  IconWindows8Color,
  IconAndroidFill,
  IconChromeFill,
  IconGoogleFill,
  IconEdgeFill,
  IconFirefoxFill,
  IconIexploreFill,
  IconIosFill,
  IconLinuxFill,
  IconMacosFill,
  IconOperaFill,
  IconOsUnknownFill,
  IconRecentFill,
  IconSafariFill,
  IconWindowsFill,
  IconWindows8Fill,
} from '@saucelabs/ds-icons';

const IconMacosFillDefault = () => (
  <IconMacosFill className="fill-current text-gray-600" />
);

const iconsMapColor = {
  // browsers
  edge: IconEdgeColor,
  microsoftedge: IconEdgeColor,
  iexplore: IconIexploreColor,
  'internet explorer': IconIexploreColor,
  chrome: IconChromeColor,
  googlechrome: IconChromeColor,
  firefox: IconFirefoxColor,
  safari: IconSafariColor,
  opera: IconOperaColor,
  // mobile
  ios: IconIosColor,
  ipad: IconIosColor,
  iphone: IconIosColor,
  android: IconAndroidColor,
  // OSes
  google: IconGoogleColor,
  linux: IconLinuxColor,
  macos: IconMacosColor,
  mac: IconMacosColor,
  windows: IconWindowsColor,
  windows8: IconWindows8Color,
};

const iconsMap = {
  recent: IconRecentFill,
  // browsers
  edge: IconEdgeFill,
  microsoftedge: IconEdgeFill,
  iexplore: IconIexploreFill,
  'internet explorer': IconIexploreFill,
  chrome: IconChromeFill,
  googlechrome: IconChromeFill,
  firefox: IconFirefoxFill,
  safari: IconSafariFill,
  opera: IconOperaFill,
  // mobile
  ios: IconIosFill,
  ipad: IconIosFill,
  iphone: IconIosFill,
  android: IconAndroidFill,
  // OSes
  google: IconGoogleFill,
  linux: IconLinuxFill,
  macos: IconMacosFillDefault,
  mac: IconMacosFillDefault,
  unknown: IconOsUnknownFill,
  windows: IconWindowsFill,
  windows8: IconWindows8Fill,
};

const PlatformIcon = ({ hasColor, name, ...otherProps }) => {
  if (typeof name !== 'string') return <IconOsUnknownFill {...otherProps} />;
  const lowerCaseName = name.toLowerCase();

  if (hasColor) {
    const Icon = iconsMapColor[lowerCaseName] || iconsMap[lowerCaseName] || iconsMap.unknown;
    return <Icon {...otherProps} />;
  }

  const Icon = iconsMap[lowerCaseName] || iconsMap.unknown;
  return <Icon {...otherProps} />;
};

PlatformIcon.propTypes = {
  hasColor: PropTypes.bool,
  name: (props, propName, componentName) => { // eslint-disable-line consistent-return
    if (typeof props[propName] !== 'string') {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}. It is type ${typeof props[propName]} and must be a string.`);
    }
    const lowerCaseName = props[propName].toLowerCase();
    if (Object.keys(iconsMap).indexOf(lowerCaseName) === -1) {
      return new Error(`Invalid prop ${propName} supplied to ${componentName}. It must be a key of iconsMap.`);
    }
  },
};

PlatformIcon.defaultProps = {
  hasColor: false,
  name: '',
};

export default PlatformIcon;
